import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@material-ui/core';

const DialogPrintStock = ({ open, data, number, handleChangeNumber, handlePrint, handleClose }) => {
    return (
        <Dialog open={open}>
            <DialogTitle>Imprimir etiqueta para { data.reference }</DialogTitle>
            <DialogContent dividers>
                <DialogContentText>¿Cuantas etiquetas quieres imprimir?</DialogContentText>
                <TextField id="standard-name" label="Numero" value={number} onChange={event => handleChangeNumber(event.target.value)} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cerrar</Button>
                <Button onClick={() => handlePrint(data, number)} color='primary'>Aceptar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogPrintStock